import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useChatbotContext } from '~chatbot/context/ChatbotContext';
import styles from './SystemResponse.module.scss';

const ChatRenderer = lazy(() => import('~chatbot/utils/ChatRenderer.js'));

function SystemResponse({
  extraClass,
  chat,
  externalTimingClass,
  externalResponseClass,
}) {
  const { getTimings } = useChatbotContext();

  return (
    <div
      className={classNames(
        { [externalResponseClass]: !!externalResponseClass },
        { [extraClass]: !!extraClass },
      )}
    >
      {chat.response === ''
        ? (
          <Suspense fallback={<div>Please wait...</div>}>
            <ChatRenderer
              mdString={
                chat.packets.map((packet) => packet.words)
                  .join('')
              || ''
              }
              className={styles.words}
            />
          </Suspense>
        )
        : (
          <Suspense fallback={<div>Try again</div>}>
            <ChatRenderer
              mdString={chat.response || ''}
            />
          </Suspense>
        )}
      <div className={classNames(
        { [externalTimingClass]: !!externalTimingClass },
      )}
      >
        {getTimings(chat.time)}
      </div>
    </div>
  );
}

SystemResponse.propTypes = {
  chat: PropTypes.object.isRequired,
  externalTimingClass: PropTypes.string.isRequired,
  externalResponseClass: PropTypes.string.isRequired,
};


export default SystemResponse;
